import React from 'react';
import PropTypes from 'prop-types';

import { FinePrintArticle, FinePrintHeading, FinePrintList } from "./styles";

const FinePrint = ({ finePrint }) => (
  <FinePrintArticle>
    <FinePrintHeading>Fine Print</FinePrintHeading>
    <FinePrintList>
      {finePrint.map(info => <li key={info}>{info}</li>)}
    </FinePrintList>
  </FinePrintArticle>
);

FinePrint.propTypes = {
  finePrint: PropTypes.instanceOf(Array),
};

export default FinePrint;
